import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from './UserContext';

const ProtectedRoute = ({ children, requiredType }) => {
  const { user } = useContext(UserContext);
  if (!user) {
    return <Navigate to="/login" />;
  }
  if (requiredType && user.type !== requiredType) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedRoute;